var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.549,
    cy: 22.1166,
    r: 22.1166,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1299_9593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4324,
    y: 10,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1299_9593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.023 15C24.1054 15 25.7936 16.6839 25.7936 18.7664C25.7936 20.8488 24.1054 22.5413 22.0273 22.5413C19.9491 22.5413 18.2566 20.8488 18.2566 18.7707C18.2566 16.6882 19.9405 15 22.023 15Z",
    fill: "#AA9A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0128 23.197C21.5302 24.8167 21.4402 27.3104 22.9656 29.0458C22.8928 29.0501 22.8328 29.0587 22.7728 29.0587C20.5876 29.0587 18.4023 29.0587 16.2213 29.0587C15.4929 29.0587 14.9915 28.5616 15.0001 27.8375C15.0044 27.3533 14.9873 26.8605 15.0772 26.3892C15.2272 25.6094 15.7585 25.0738 16.3798 24.6281C17.2711 23.9897 18.2866 23.6426 19.3449 23.4112C20.489 23.1584 21.6459 23.1027 22.8114 23.1541C22.8542 23.1541 22.8971 23.1627 22.9399 23.1713C22.9571 23.1713 22.9785 23.1841 23.0128 23.197Z",
    fill: "#AA9A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1451 22.5457C28.1247 22.5457 29.7401 24.161 29.7401 26.1406C29.7401 28.1288 28.1204 29.7485 26.1322 29.7442C24.144 29.7399 22.5372 28.1202 22.5415 26.1278C22.5458 24.1482 24.1612 22.5457 26.1451 22.5457ZM24.2126 26.3463C24.294 26.4706 24.354 26.6334 24.4654 26.7148C24.8082 26.9719 25.1681 27.2033 25.5281 27.4304C25.7509 27.5718 25.9651 27.5461 26.1536 27.3618C26.7321 26.7919 27.3148 26.2221 27.8719 25.6307C27.9704 25.5279 28.0218 25.3094 27.9918 25.1637C27.9104 24.7524 27.4391 24.6409 27.122 24.9452C26.6935 25.3651 26.2693 25.7893 25.8494 26.2178C25.7594 26.312 25.6909 26.3292 25.5795 26.2478C25.3909 26.1107 25.1938 25.9735 24.9882 25.8621C24.6625 25.6779 24.2512 25.9393 24.2126 26.3463Z",
    fill: "#AA9A89"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/active-users.376683b2eac7e4501d4c4e2686d50e4b.svg";
export { ForwardRef as ReactComponent };